import { __assign } from "tslib";
// DS: I32
// from Phrac T36082
import React from 'react';
import IconWrap from '../IconWrap';
var CloseBold = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { fillRule: "evenodd" },
            React.createElement("path", { d: "M4 6.182L6.182 4 20 17.818 17.818 20z" }),
            React.createElement("path", { d: "M20 6.182L6.182 20 4 17.818 17.818 4z" }))))); };
CloseBold.displayName = 'CloseBold';
export default CloseBold;
//# sourceMappingURL=CloseBold.js.map